import * as React from 'react'
import classNames from 'classnames'

import type { LinkType } from 'types'
import Button from 'content-components/_Primatives/Button'
import Paragraph from 'content-components/_Primatives/Paragraph'

import style from './style.scss'

export type Props = {
  className?: string
  date: string
  hasSeminarLabel?: boolean
  isOnlineSeminar?: boolean
  link: LinkType
  location: string
  locationName: string
  seminarLabelText: string
  startAndEndTime?: string
}

LocationCourseCard.defaultProps = {
  className: '',
}

function LocationCourseCard(props: Props) {
  const {
    className,
    date,
    hasSeminarLabel,
    isOnlineSeminar,
    link,
    location,
    locationName,
    seminarLabelText,
    startAndEndTime,
  } = props
  const { text, url, target } = link

  return (
    <div className={classNames(style.wrapper, className)}>
      {hasSeminarLabel && (
        <Paragraph className={style.seminarLabel}>{seminarLabelText}</Paragraph>
      )}
      {(isOnlineSeminar && (
        <>
          <Paragraph className={style.location}>Online</Paragraph>
          <Paragraph className={style.date} small>
            {date}
            <br />
            {startAndEndTime}
          </Paragraph>
        </>
      )) || (
        <>
          <Paragraph className={style.location}>{location}</Paragraph>
          <Paragraph className={style.date} small>
            {date}
            <br />
            {locationName}
          </Paragraph>
        </>
      )}
      <Button
        className={style.button}
        target={target}
        url={url}
        variant='secondaryBlack'
      >
        {text}
      </Button>
    </div>
  )
}

export default LocationCourseCard
